import { createElement } from 'react';
import { Icon } from '@alifd/next';
const Icons = function Icons({ type, size, style: styleOption = {}, }) {
    return (createElement(Icon, { type: type, size: size, style: styleOption }));
};
export default Icons;
